// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"AqAzkI","titleValue":"_73e7gL","block":"gXSTUk","isOpen":"UqorUc","title":"YRTcXm","icon":"kaphe_","list":"_wzyIW","currencyLogo":"tU1Q3C"};